<template>
  <div class="msg">
    <div v-if="img">
      <img :src="img" alt />
    </div>
    <div class="text">
      <h2>{{btnText}}</h2>
      <p>{{description}}</p>
    </div>
    <van-button type="info" size="large" @click="submit">{{btnText}}</van-button>
  </div>
</template>
<script>
export default {
  name: "attention",
  data() {
    return {
      btnText: "关注云就业",
      img: "img/yunjiuye.jpg",
      description: "关注云就业公众号,实时接收面试动态消息" // 已关注的用户: 请注意在云就业服务号查收面试动态消息
    };
  },
  created() {},
  methods: {
    submit() {
      location.href =
        "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwODcwNTIxMA==#wechat_redirect";
    }
  }
};
</script>

<style lang="scss" scoped>
.msg {
  background-color: #fbf9fe;
  padding: 0.3rem 0.15rem;
  img {
    max-width: 1.5rem;
    max-height: 1.5rem;
  }
  .text {
    margin: 0.3rem 0;
    line-height: 1.5;

    h2 {
      font-weight: bold;
      font-size: 0.16rem;
      color: #3a3a3a;
    }

    p{
        font-size: 0.14rem;
        color: #999;
    }
  }
}
</style>
